<div class="card" [ngClass]="{ 'container-fluid': mobileMode(), 'p-0': mobileMode() }" style="min-height: 570px"
  [style.background-color]="clozeTestStyleModel().exerciseBackground" [ngStyle]="{
        border: mobileMode() ? '0' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0' : '8px',
        width: mobileMode() ? '' : '720px',
      }">
  <!-- mobile exercise header -->
  <div class="onset-indicator d-flex justify-content-between" style="align-items: center">
    <div>
      @if (!exampleDone) {
      <span class="font-weight-bold">{{ lang().toLowerCase() === 'de' ? 'Beispiel' : 'Example' }}</span>
      }
    </div>
  </div>
  <div class="card-body card-mobile" [style.font-family]="clozeTestStyleModel().font"
    [style.font-size]="this.clozeTestStyleModel().fontSize">
    @if (!exampleDone) {
    <div>
      <div class="card-title-row">
        <h4 class="card-title">{{ title }}</h4>
      </div>
      <!-- Content -->
      <div [style.line-height]="lineHeight">
        @for (input of inputs; track input; let i = $index) {
        <cloze-test-exercise-input [mobileMode]="true" [nr]="$any(input.id)" [text]="input.text"
          [isLast]="i === inputs.length - 1" [lastWord]="input.lastWord" [answer]="input.answer"
          [clozeTestStyleModel]="clozeTestStyleModel()">
        </cloze-test-exercise-input>
        }
      </div>
      <!-- Next button -->
      <div class="text-center">
        <div class="row justify-content-around">
          <div class="col-3"></div>
          <div class="col-4" style="padding-top: 4px">
            <input type="checkbox" style="vertical-align: middle" id="finishCheckbox" name="finishCheckbox"
              [checked]="readyCheckbox" (change)="readyCheckbox = !readyCheckbox" />
            <label for="finishCheckbox" style="font-size: smaller; padding-left: 6px">
              {{ lang().toLowerCase() === 'de' ? 'Fertig' : 'Text completed' }}
            </label>
          </div>
          <div class="col-3">
            <button class="btn" style="font-size: smaller" (click)="toggleExampleDone()" [hidden]="!readyCheckbox"
              [disabled]="!readyCheckbox" [style.background-color]="cTestButtonColor()">
              {{ lang().toLowerCase() === 'de' ? 'Weiter' : 'Next' }}
            </button>
          </div>
          <div class="col-2"></div>
        </div>
      </div>
    </div>
    }
    @if (exampleDone) {
    <div>
      <div class="pl-0 pr-0 text-center" style="padding-top: 200px">
        <div>
          @if (lang().toLowerCase() === 'de') {
          <p class="card-text">Tippen Sie jetzt auf "Test starten", um den ersten Text zu bearbeiten.</p>
          } @else {
          <p class="card-text">Now click on "Start test" in order to proceed to the first text.</p>
          }
        </div>
        <div class="container p-0 mt-4">
          <div class="row no-gutters">
            <button class="btn justify-content-center" style="font-size: smaller"
              [style.background-color]="cTestButtonColor()" (click)="toggleStartTest()">
              {{ lang().toLowerCase() === 'de' ? 'TEST STARTEN' : 'START TEST' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
